import React from "react";

import LoaderImg from "../../assets/Loader/Loading.gif";

import "./index.scss";

const PageLoading = ({ customHeight, backgroundColor }) => {
  customHeight = customHeight || "calc(100vh - 48px)";
  backgroundColor = backgroundColor || "transparent";
  return (
    <div className="loader-wrapper" style={{ height: customHeight, backgroundColor: backgroundColor }}>
      <img className="loaderImg" src={LoaderImg} alt="loader-img" />
    </div>
  );
};

export const OverlayLoader = ({ customHeight }) => {
  customHeight = customHeight || "100%";
  return (
    <div className="loader-overlay">
      <PageLoading backgroundColor="var(--translucent-white)" customHeight={customHeight} />
    </div>
  );
};

export default PageLoading;
